<template>
<div class="chapter">
<div class="inner_page">
<p class="C671"><strong><a id="page_45">III</a></strong></p><a id="page_45">
<p class="C662"><em>The Empowerment of the Founders (1950–1960)</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 14_THREE__The_Empowerment_of_the_Fo.vue?f13f3284